import React from "react";
import classes from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import BottomToTop from "../../../../../../components/transitions/bottom-to-top";
import { FormattedMessage } from "react-intl";
import { BlackMask } from "../../../../../../components/mask";
import { unitPrice } from "../../../../../../../utils/product";

const TotalDiscountPopup = props =>{
    const { onClose, summary, summaryMsg,importantFontSize,paddingBottom100 } = props;

    return <div className={`${classes.TotalDiscountPopup} ${!summaryMsg ? classes.PaddingBottom120 : ""} ${paddingBottom100 ? classes.PaddingBottom100 : ""}`}>
        <div className={classes.Hd}>
            <span className={classes.Title}><FormattedMessage id="details" defaultMessage="Details" /></span>
            <Iconfont className={classes.CloseIcon} onClick={onClose}>&#xe7c9;</Iconfont>
        </div>

        <div className={classes.Bd}>
            {
                summary?.display?.map((discount, index) =>(
                    <div className={classes.DiscountContainer} key={index}>
                        <div className={`${classes.Name} ${importantFontSize?classes.ImportantFontSize:''}`}>
                            <span dangerouslySetInnerHTML={{ __html: discount.label }}></span>
                        </div>

                        <div className={`${classes.Price} ${importantFontSize?classes.ImportantFontSize:''}`}>
                            {
                                discount.valueFlag && <span className={classes.ValueFlag}>{discount.valueFlag}</span>
                            }

                            <span dangerouslySetInnerHTML={{ __html: discount.value }}></span>
                        </div>
                    </div>
                ))
            }
        </div>
    </div>
}


export default props =>{
    useStyles(classes);
    const { show, onClose } = props;

    return <React.Fragment>
        <BottomToTop in={show} className={classes.TotalDiscountPopupContainer}>
            <div>
                <TotalDiscountPopup {...props} />
            </div>
        </BottomToTop>
        {show && <BlackMask onClick={onClose} style={{ zIndex: 2 }} />}
    </React.Fragment>
};